module.exports = __webpack_public_path__ + "images/emoji/closed_lock_with_key.3e1983b4adcf5cb9713d.png";